import { render, staticRenderFns } from "./GroupedStockItemsTable.vue?vue&type=template&id=aa4e9304&scoped=true&"
import script from "./GroupedStockItemsTable.vue?vue&type=script&lang=ts&"
export * from "./GroupedStockItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedStockItemsTable.vue?vue&type=style&index=0&id=aa4e9304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4e9304",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
